import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 16/19;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 18.286A2.285 2.285 0 0010.285 16h-4.57A2.285 2.285 0 008 18.286zM15.693 12.939c-.69-.742-1.982-1.857-1.982-5.51 0-2.775-1.945-4.997-4.569-5.542v-.744a1.143 1.143 0 10-2.284 0v.744c-2.624.545-4.57 2.767-4.57 5.542 0 3.653-1.29 4.768-1.98 5.51-.215.23-.31.506-.308.775a1.144 1.144 0 001.146 1.143h13.708c.682 0 1.142-.557 1.146-1.143a1.115 1.115 0 00-.307-.775z" fill={color} fillRule="evenodd" />
    </svg>
)

export default class IconActivity extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
